import { AnimatePresence, motion } from 'motion/react';
import React from 'react';

const Accordion = ({ isOpen, children, className }) => {
  return (
    <AnimatePresence initial={false}>
      {isOpen && (
        <motion.section
          className={className}
          key="content"
          initial="collapsed"
          animate="open"
          exit="collapsed"
          variants={{
            open: {
              opacity: 1,
              height: 'auto',
              overflow: 'visible',
            },
            collapsed: { opacity: 0, height: 0, overflow: 'hidden' },
          }}
          transition={{ duration: 0.15 }}
        >
          {children}
        </motion.section>
      )}
    </AnimatePresence>
  );
};

export default Accordion;
